import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import { HeadingMBold } from 'components/Typography/Typography';
import React, { Dispatch, SetStateAction } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/otpDialog';
import { makeStyles } from '@material-ui/core';
import OtpTab from 'views/Numbers/Details/Settings/subcomponents/ResetAdslPasswordDialog/subcomponents/OtpTab';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IOtpDialog {
	otp: string;
	setOtp: Dispatch<SetStateAction<string>>;
	isOpen: boolean;
	isWrongOtp: boolean;
	onSubmit: () => void;
	onClose: () => void;
	heading?: string;
	description?: string;
	submitText?: string;
	closeText?: string;
	setIsWrongOtp?: (s: boolean) => void;
	loading?: boolean;
	sendOtp: () => void;
	error?: string;
	showResendOption?: boolean;
	showOTPNote?: boolean;
}

const OtpDialog: React.FC<IOtpDialog> = ({
	otp,
	heading,
	description,
	submitText,
	closeText,
	setOtp,
	isOpen,
	onSubmit,
	isWrongOtp,
	onClose,
	setIsWrongOtp,
	loading = false,
	sendOtp,
	error,
	showResendOption,
	showOTPNote,
}) => {
	const classes = useStyles();

	const handleClose = () => {
		setOtp('');
		onClose();
		setIsWrongOtp?.(false);
	};

	const submitOTP = () => {
		onSubmit();
		setOtp('');
	};

	return (
		<CustomDialog
			isOpen={isOpen}
			hideDialog={handleClose}
			header={heading}
			disableBackdropClick
			dialogBody={
				<>
					{description && (
						<div className={classes.otpDescription}>
							<HeadingMBold>{translate('change.number.verification')}</HeadingMBold>
						</div>
					)}
					<div className={classes.otpWrapper}>
						<OtpTab
							otp={otp}
							setOtp={setOtp}
							otpIncorrect={isWrongOtp}
							sendOtp={() => {
								setIsWrongOtp?.(false);
								sendOtp();
							}}
							error={error}
							showOTPNote={showOTPNote}
							submitOTP={submitOTP}
							{...(showResendOption && { showResendOption: true, resendDelay: 0 })}
						/>
					</div>
				</>
			}
			rightSideButtons={[
				{
					text: closeText ?? translate('cancel'),
					onClick: handleClose,
					color: 'tertiary-light' as types.theme.buttonColor,
				},
				{
					text: submitText ?? translate('submit'),
					color: 'primary-light',
					onClick: submitOTP,
					disabled: otp.length !== 5,
				},
			]}
			loading={loading}
		/>
	);
};

export default OtpDialog;
